import { MessagingService } from 'src/app/services/messaging.service';
import { Injectable, NgZone, OnInit } from '@angular/core';
import { PluginListenerHandle } from '@capacitor/core';

import { Network, ConnectionStatus } from '@capacitor/network';

//const { Network } = Plugins;

@Injectable({
  providedIn: 'root',
})
export class NetworkService {
  handler: PluginListenerHandle;
  networkStatus: ConnectionStatus;

  constructor(private messagingService: MessagingService) {
    Network.addListener('networkStatusChange', (status) => {
      this.networkStatus = status;
      this.messagingService.networkStatusChanged.emit(this.isOnline());
    }).then((handler) => {
      this.handler = handler;
    });
    Network.getStatus().then((status) => {
      this.networkStatus = status;
      this.messagingService.networkStatusChanged.emit(this.isOnline());
    });
  }

  public isOnline() {
    if (this.networkStatus) {
      return this.networkStatus.connected;
    } else {
      return false;
    }
  }
}
